import { render, staticRenderFns } from "./SummitWistiaVideoGroupEditor.vue?vue&type=template&id=7c33a264&"
import script from "./SummitWistiaVideoGroupEditor.vue?vue&type=script&lang=js&"
export * from "./SummitWistiaVideoGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports